// Common-password screening (ASVS 2.1.7). A short embedded list of passwords that
// meet the 12-character minimum yet appear at the top of breach corpora, plus
// low-effort patterns. A full breached-password check (HIBP k-anonymity) is a
// production-hardening follow-up (Milestone 9).
const COMMON = new Set([
    '123456789012',
    '1234567890123',
    '12345678910',
    '123456789123',
    '1q2w3e4r5t6y',
    '1qaz2wsx3edc',
    'aaaaaaaaaaaa',
    'abc123456789',
    'abcdefghijkl',
    'administrator',
    'changeme1234',
    'letmein12345',
    'iloveyou1234',
    'password1234',
    'password12345',
    'password123!',
    'passw0rd1234',
    'p@ssw0rd1234',
    'p@ssword1234',
    'qwerty123456',
    'qwertyuiop12',
    'qwertyuiop123',
    'qwertyuiopas',
    'welcome12345',
    'welcome123!!',
    'zaq12wsxcde3',
    'trustno1trustno1',
    'sunshine1234',
    'football1234',
    'baseball1234',
    'princess1234',
    'monkey123456',
    'dragon123456',
    'master123456',
    'superman1234',
    'warehouse123',
    'warehouse1234',
    'logistics123',
    'logistics1234',
    'zenarty12345',
    'zenartywms123',
]);
// Runs of digits, the alphabet and keyboard rows (forwards and backwards), repeated so
// any wrap-around slice of them is caught.
const SEQUENCES = ['0123456789', 'abcdefghijklmnopqrstuvwxyz', 'qwertyuiopasdfghjklzxcvbnm']
    .flatMap((s) => [s, [...s].reverse().join('')])
    .map((s) => s.repeat(Math.ceil(256 / s.length)));
/** Returns a reason when the password is too guessable, else null. */
export function weakPasswordReason(password) {
    const lower = password.toLowerCase();
    if (COMMON.has(lower))
        return 'This password is too common';
    if (/^(.)\1+$/.test(password))
        return 'Do not repeat a single character';
    if (SEQUENCES.some((seq) => seq.includes(lower)))
        return 'Do not use a keyboard or alphabet sequence';
    return null;
}
//# sourceMappingURL=passwords.js.map